import { useContext, useEffect, useRef } from "react";
import UploadInput from "./components/UploadInput";
import ExampleCards from "./components/ExampleCards";
import MiddleComp from "../MiddleComp";
import { GenerateContext } from "../hooks/GenerateContext";
import { AppContext } from "@utils/AppContext";
import { IMAGE_TYPE } from "@utils/CONST";
import eventBus from "@utils/eventBus";
import styles from "./index.module.scss";

const CreativeToImage = () => {
    const { projectId, setMatchImages } = useContext(GenerateContext);
    const { setGlobalTaskReadFlag } = useContext(AppContext);
    const middleRef = useRef(null);
    const creativeToImageRef = useRef(null);

    const createClick = () => {
        setGlobalTaskReadFlag((prev) => !prev);
        if (middleRef.current) middleRef.current.fetchProjectDetail();
        if (creativeToImageRef.current) creativeToImageRef.current.scrollTop = 0;
    };

    useEffect(() => {
        const handleCreativeToImageUpload = (url) => {
            if (!url) return;
            setMatchImages([{ url }]);
            if (creativeToImageRef.current) {
                creativeToImageRef.current.scrollTop = 0;
            }
        };

        eventBus.on("creativeToImageAutoUpload", handleCreativeToImageUpload);
        return () => {
            eventBus.off("creativeToImageAutoUpload", handleCreativeToImageUpload);
        };
    }, [setMatchImages]);

    return (
        <div
            className={[
                styles.CreativeToImage,
                projectId ? styles.CreativeToImageGenerating : "",
                "_beauty_scrollbar",
            ].filter(Boolean).join(" ")}
            ref={creativeToImageRef}
        >
            {!projectId && (
                <video className={styles.BgVideo} autoPlay loop muted playsInline>
                    <source
                        src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/creative-to-image/bg.mp4"
                        type="video/mp4"
                    />
                </video>
            )}
            <div className={styles.ContentWrap}>
                {!projectId && (
                    <div className={styles.TitleWrap}>
                        <h2 className={styles.TitleImage}></h2>
                        <p></p>
                    </div>
                )}
                {projectId ? <MiddleComp ref={middleRef} imageType={IMAGE_TYPE.CREATIVE_IMAGE_GEN} /> : null}
                <UploadInput createClick={createClick} />
                {!projectId && <ExampleCards />}
                <div className={projectId ? styles.BottomSpaceGenerating : styles.BottomSpace}></div>
            </div>
        </div>
    );
};

export default CreativeToImage;
